import { KpiGrid, KpiTile, type KpiDetail } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import type { StageTotal, StatisticsFormat } from './statistics.ts';

export type StageTilesProps<Stage extends string> = {
  stages: Readonly<Record<Stage, StageTotal>>;
  order: readonly Stage[];
  labelPrefix: string;
  format: StatisticsFormat;
  loading: boolean;
};

export const StageTiles = <Stage extends string>({
  stages,
  order,
  labelPrefix,
  format,
  loading,
}: StageTilesProps<Stage>) => {
  const { t } = usePageContext();
  const detailsOf = (total: StageTotal): KpiDetail[] => [
    { label: t('statistics.value'), value: format.money(total.value) },
    ...(total.margin === null ? [] : [{ label: t('statistics.margin'), value: format.money(total.margin) }]),
  ];
  return (
    <KpiGrid>
      {order.map((stage) => (
        <KpiTile
          key={stage}
          label={t(`${labelPrefix}${stage}`)}
          loading={loading}
          value={format.count(stages[stage].count)}
          details={detailsOf(stages[stage])}
        />
      ))}
    </KpiGrid>
  );
};
